// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { subscribeStyles } from "@turnerBlueprint/Overrides/Widgets/Basic/Subscribe";
import { color } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

subscribeStyles.mainGridContainer = {
    gap: 0,
};

subscribeStyles.titleLabel = {
    variant: "h4",
    forwardAs: "span",
    color: "common.white",
    css: css`
        margin-bottom: 8px;
    `,
};

subscribeStyles.emailGridItem = {
    width: 12,
    css: css`
        position: relative;
        overflow: hidden;
    `,
};

subscribeStyles.emailTextField = {
    mergeCss: true,
    cssOverrides: {
        formInputWrapper: css`
            &&& input {
                padding-right: 110px; // 103px  button width + 9 input field padding: ;
                height: 32px;
                box-shadow: inset 0 1px 0 0 ${color("common.ui7", 0.2)}, inset -104px 0px ${color("common.ui8")};
            }
        `,
    },
};

subscribeStyles.emailButton = {
    sizeVariant: "small",
    css: css`
        position: absolute;
        min-height: 30px;
        right: 1px;
        top: 1px;
        border-radius: unset;
        ${TypographyStyle} {
            font-size: 14px;
        }
    `,
};
subscribeStyles.titleGridItem = {
    width: 12,
    css: css`
        justify-content: start;
    `,
};

subscribeStyles.descriptionGridItem = {
    width: 12,
    css: css`
        justify-content: start;
    `,
};

subscribeStyles.descriptionText = {
    color: "common.white",
    css: css`
        && {
            margin-bottom: 12px;
            ${TypographyStyle} {
                font-size: 12px;
                line-height: 20px;
                margin-bottom: 0;
            }
        }
    `,
};
